import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { getResponsiveStyle } from '../../../utils/getResponsiveStyle';
import { FemaleGenderIcon, MaleGenderIcon } from '../../common/icons';
import ProfileIcon from '../../common/ProfileIcon';

type Props = {
	gender: 'MALE' | 'FEMALE';
	image?:string;
	showGender?: boolean;
	profileImage?: string;
};

export const ProfileImageWithGender = ({
	gender,
	image,
	showGender = true,
	profileImage,
}: Props) => {
		
	return (
		<View style={styles.imageContainer}>
			<ProfileIcon  source={image?{uri:image}:false} style={styleProfileContainer()} />
			{showGender && (
				<View
					style={[
						styles.userGenderContainer,
						styleUserGenderContainer(),
					]}
				>
					{gender === 'MALE' && <MaleGenderIcon />}
					{gender === 'FEMALE' && <FemaleGenderIcon />}
				</View>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	imageContainer: {
		position: 'relative',
		alignSelf: 'center',
	},
	profileImage: {},
	userGenderContainer: {
		position: 'absolute',
		left: '46%',
	},
});

const styleUserGenderContainer = () => {
	return {
		width: getResponsiveStyle(18, 'dimensions'),
		height: getResponsiveStyle(18, 'dimensions'),
		bottom: getResponsiveStyle(-9, 'dimensions'),
		transform: [
			{
				translateX: getResponsiveStyle(-9, 'dimensions'),
			},
		],
	};
};

const styleProfileContainer = () => {
	return {
		width: getResponsiveStyle(80, 'dimensions'),
		height: getResponsiveStyle(80, 'dimensions'),
	};
};
